$(document).ready(function() {
    //E-mail Ajax Send

    function textMassage (caption, description) {
        return (
            `<div class="message">
                <h2 class="text-center">${caption}</h2>
                <h3 class="text-center">${description}</h3>
                <button style="margin: 0 auto;" class="btn" onClick="$.fancybox.close()">Закрыть</button>
            </div>`
            )
    }

    function textMassageSwap(url) {
        if(url === '/reviews') {
            return  textMassage('Спасибо за отзыв', 'После модерации, отзыв появится на сайте');
        }
        if(url === '/obituary') {
            return  textMassage('Спасибо за некролог', 'После модерации, некролог появится на сайте');
        }
        return  textMassage('Спасибо за заказ', 'Скоро с вами свяжутся наши менеджеры');
    }

    $(".form").each(function() {
        $(this).submit(function() { //Change
            var utlOrder = $(this).data("url");
            var th = $(this);
            $.ajax({
                type: "POST",
                url: utlOrder, //Change
                data: th.serialize(),
                beforeSend : function() {
                    $("#button").prop('disabled', true);
                }
            }).done(function() {
                $.fancybox.close();
                $.fancybox.open(textMassageSwap(utlOrder));
                setTimeout(function() {
                    // Done Functions
                    $("#button").prop('disabled', false);
                    th.trigger("reset");
                }, 1000);
            }).fail(function(data){
                $("#button").prop('disabled', false);
                $.fancybox.open(
                    '<div class="message"><h3 class="text-center">Не удалось отправить форму.</h3> <h3 class="text-center">Попробуйте еще раз</h3><button style="margin: 0 auto;" class="btn" onclick="$.fancybox.close()">Ок</button></div>');
            });
            return false;
        });
    });
});